import { DateTime } from "luxon"

import { authFetch } from "@/api/authFetch.ts"
import { API_BASE } from "@/config.ts"

import type { Farm } from "../types/logisticsTypes.ts"

export const getFarm = async (id: number): Promise<Farm> => {
  const start = DateTime.now()
    .setZone("America/Chicago")
    .minus({ days: 1 })
    .startOf("month")
    .toISO()

  const end = DateTime.now().setZone("America/Chicago").minus({ days: 1 }).endOf("month").toISO()

  const res = await authFetch(
    `${API_BASE}/logistics/farms/${id}?includeTrips=true&tripAggregation=Monthly&timezone=America/Chicago&start=${start}&end=${end}`,
  )

  const data: Farm = await res.json()
  return data
}
